module.exports = __webpack_public_path__ + "img/wait.1cc23b31.png";